import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('GET_LOG_REPORTS_GRAPH')
};

export default TYPES;
